import { Text } from '@/components/ui/text';
import { Textarea, TextareaInput } from '@/components/ui/textarea';
import { HStack } from '@/components/ui/hstack';
import React, { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import ModalBase from './ModalBase';
import BasicButton from '@/components/basic/BasicButton';
import i18n from 'i18n-js';
import { changeState } from '@/stores/mainSlice';

export default function ModalPrompt({ prompt, showModal, setShowModal }) {
    let [actualKey, setActualKey] = useState('base');
    let [selectedText, setSelectedText] = useState(prompt[actualKey]);
    let [newPrompt, setNewPrompt] = useState({ ...prompt });

    const dispatch = useDispatch();

    const onChangeText = useCallback((text) => {
        setSelectedText(text);
    }, []);

    const onClose = (isOk) => {
        if (isOk) {
            dispatch(changeState({ changes: { ai: { prompt: newPrompt } } }));
        }
        setShowModal(false);
    };

    const changeKey = (key) => {
        if (key != actualKey) {
            if (typeof prompt[actualKey] === 'object') {
                try {
                    const parsed = JSON.parse(selectedText);
                    setNewPrompt((prevPrompt) => ({
                        ...prevPrompt,
                        [actualKey]: parsed
                    }));
                } catch (e) {
                    alert(i18n.t('studio.flow.aiInvalidJSON', {error: e.message}));
                }
            } else {
                setNewPrompt((prevPrompt) => ({
                    ...prevPrompt,
                    [actualKey]: selectedText
                }));
            }
            if (typeof prompt[key] === 'object') {
                setSelectedText(JSON.stringify(newPrompt[key], null, 2));
            } else {
                setSelectedText(newPrompt[key]);
            }
            setActualKey(key);
        }
    };

    return (
        <ModalBase className="max-w-[1100px] max-h-[90%]" showModal={showModal} setShowModal={onClose} title={'studio.flow.aiEdit'} onButton={onClose} buttonL={'studio.flow.aiCancel'} buttonR={'studio.flow.aiOk'} disabled={false}>
            <HStack className="items-center gap-2 mb-2">
                {Object.keys(prompt).map((key) => (
                    <BasicButton
                        key={key}
                        width="100px"
                        bg={key == actualKey ? 'bg-ina-green' : 'bg-primary-900'}
                        onPress={() => {
                            changeKey(key);
                        }}
                        text={key}
                    />
                ))}
            </HStack>
            <Text className="text-md text-secondary-900">{i18n.t(typeof newPrompt[actualKey] === 'object' ? 'studio.flow.aiFormatJSON' : 'studio.flow.aiFormatText')}</Text>
            <Textarea size="md" className="h-[600px] bg-secondary-50">
                <TextareaInput key={actualKey} className="web:text-primary-900 placeholder:text-secondary-400" selectionColor="#D2D4D7" multiline={true} defaultValue={selectedText} onChangeText={onChangeText} />
            </Textarea>
        </ModalBase>
    );
}
